
import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { getSelectOptions } from "utils/optionHelper";
import FormDatePicker from "Common/Custom/ReactFlatpickr";

const AttendanceForm = ({
    fields,
    values,
    errors,
    employees,
    handleChange,
    handleSubmit,
    loading,
    title
}) => {
    const statusOptions = [
        { id: 'present', name: 'Present' },
        { id: 'absent', name: 'Absent' },
        { id: 'leave', name: 'Leave' },
        { id: 'half_day', name: 'Half Day' }
    ];

    const optionConfig = {
        employee_id: {
            list: employees,
            valueKey: "employee_id",
            labelKey: "first_name",
            concat: ["first_name", "last_name"]
        },
        status: {
            list: statusOptions,
            valueKey: "id",
            labelKey: "name"
        }
    };

    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>{title}</HeadingOne>
        }>
            {fields.map((field) => {
                if (field.type === "select") {
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={getSelectOptions(field.name, optionConfig)}
                            error={errors[field.name]}
                        />
                    );
                }

                if (field.type === "date" || field.type === "datetime") {
                    return (
                        <FormDatePicker
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            mode={field.type}
                            error={errors[field.name]}
                        />
                    );
                }

                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Save"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AttendanceForm;
